import React from "react";
import { useTranslation } from "react-i18next";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";

const InputsYorN = ({ translationKey, onChange, value }) => {
  const { t } = useTranslation();

  const handleChange = (event) => {
    onChange(event.target.value); // Notifica al padre el valor seleccionado
  };

  return (
    <Box sx={{ mt: 2 }}>
      <FormControl component="fieldset" margin="normal">
        <FormLabel component="legend">{t(translationKey)}</FormLabel>
        <RadioGroup row value={value} onChange={handleChange}>
          <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
          <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default InputsYorN;